import { cn } from '../../lib/cn';
import type { MarketplaceValidationRow } from '../../enterpriseacceptance/framework';

type Props = { validations?: MarketplaceValidationRow[] };

export function MarketplaceValidationPanel({ validations = [] }: Props) {
  return (
    <div className="grid gap-2 sm:grid-cols-2">
      {validations.map((v) => (
        <div key={v.area} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-2">
            <p className="text-sm font-medium">{v.area}</p>
            <span className={cn(
              'text-xs font-medium',
              v.status === 'validated' ? 'text-success-600' : 'text-brand-600',
            )}>
              {v.score}%
            </span>
          </div>
          <p className="mt-1 text-xs text-slate-500">{v.evidence}</p>
        </div>
      ))}
    </div>
  );
}
